// Typelizer digest e4e582dd6d8604d1537f313893422ee7
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /admin/productions/:production_id/takes/:id/audio */
  audio: (
    params: { productionId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/admin/productions/:production_id/takes/:id/audio', params, options),
    method: 'get',
  }),

  /** POST /admin/productions/:production_id/takes/:id/select */
  select: (
    params: { productionId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/admin/productions/:production_id/takes/:id/select', params, options),
    method: 'post',
  }),
}
